/**
 * Created by mathias.gamperl on 03.02.2015.
 */
export default ["$window", "$uibModal", "Utils", "$log", "$rootScope", "ServiceRA", "DialogService", "AuthenticationService", "moment", "$q", "$timeout", "ConfigService", function SessionExpirationService($window, $uibModal, Utils, $log, $rootScope, ServiceRA, DialogService, AuthenticationService, moment, $q, $timeout, ConfigService) {

  var initialRequest = true;

  var dialogVisible = false;

  var logoutAfterTimeInSeconds = ConfigService.get("sessionExpiration.logoutAfterTimeInSeconds", true);
  var abortGet = $q.defer();

  var dialog;

  function showExpirationDialog() {
    dialogVisible = true;

    dialog = DialogService.showDialog(require("./sessionExpirationDialog.tpl.html"), "SessionExpirationDialogController", null, null, "static");

    dialog.result.then(function () {
      dialogVisible = false;
      extendSession();
    }, function () {
      dialogVisible = false;
      //$log.debug("cancel expiration dialog");
    });
  }

  function getSesionInformation() {
    //$log.log("SE:", "get session information");
    var defer = $q.defer();

    if (abortGet) {
      abortGet.promise.isGloballyCanceled = true;
      abortGet.resolve();
    }
    abortGet = $q.defer();

    //console.log("SE:", "check expirationTime time ", isActive());
    ServiceRA.all('expirationTime').withHttpConfig({
      canNotBeBlocked: true,
      timeout: abortGet.promise
    }).customGET().then(function (data) {

      var res = {};

      res.timeout = moment(data.expTime, moment.ISO_8601).local();
      res.secondsToTimeout = data.expInSeconds !== undefined ? data.expInSeconds : parseInt((res.timeout.diff(moment())) / 1000);
      res.alertTimeout = (res.secondsToTimeout <= ConfigService.get("sessionExpiration.showDialogAtSeconds", true));
      res.logoutUser = (res.secondsToTimeout <= ConfigService.get("sessionExpiration.logoutAtSeconds", true));
 
      defer.resolve(res);
    }, function (response) {

      //console.log("error request = ", response);

      if (response.status === 0 || (response.config.timeout.isGloballyCanceled === true)) {
        //$log.debug("aborted request: ", response);
        //console.log("response status: ", response.status);
        defer.resolve(response);
      }
      else {
        $log.error(response);
        //defer.resolve(response);
        defer.reject(response);
      }
    });

    return defer.promise;
  }

  function extendSession() {
    //console.log("SE:","extend session");

    var defer = $q.defer();

    ServiceRA.all('extendTokenExpiration').post().then(function (data) {
      //console.log("session extended");
      checkSession();
      defer.resolve(data);
    }, function (response) {
      Utils.handleError(response);
      defer.reject(response.status);
      doLogout();
    });

    dialogVisible = false;

    return defer;
  }

  function doLogout() {
    // console.log("SE:","do logout");
    disable();

    if (dialog) {
      dialog.dismiss("logout");
    }
    DialogService.closeAllDialogs();
    //console.log("doLogout");
    return AuthenticationService.logout(null, null, null, "logoutSessionExpired", true);
  }

  function rescheduleCheck(time) {
    //console.log("rescheduleCheck: ", time);
    AuthenticationService.setCheckSessionTimeout(checkSession, time);
    //console.log("SE:","check session again", dialogVisible,AuthenticationService.isAuthenticated(),(result.secondsToTimeout / 2)*1000);
  }

  function checkSession() {
    if (AuthenticationService.isAuthenticated()) {
      return getSesionInformation().then(function (result) {

        //console.log("sessioninformation ", result);

        if (ConfigService.get("sessionExpiration.forceSessionExpirationDialog", true) && !dialogVisible) {
          showExpirationDialog();
        }

        $rootScope.sessionInformation = result;

        var checkInterval = ConfigService.get("sessionExpiration.checkSessionIntervalInSeconds", true, (parseInt(result.secondsToTimeout) / 2)) * 1000;

        if(logoutAfterTimeInSeconds<=0){
          doLogout();
        }
        if(logoutAfterTimeInSeconds){
          logoutAfterTimeInSeconds-=(checkInterval/1000);
        }

        if (result.alertTimeout) {
          if (result.logoutUser) {
            //console.log("logout user ");
            doLogout();
          }
          else {
            if (dialogVisible) {
              rescheduleCheck(1000);
            }
            else {
              if (ConfigService.get("sessionExpiration.extendSessionAutomatically", true)) {
                extendSession();
              }
              else {
                showExpirationDialog();
              }
              rescheduleCheck(checkInterval);
            }
          }
        }
        else {
          if (dialogVisible) {
            rescheduleCheck(1000);
          }
          else {
            if (result.secondsToTimeout) {
              // console.log("rescheduleCheck in "+ (parseInt(result.secondsToTimeout) / 2) +" seconds");
              rescheduleCheck(Math.max(checkInterval, 5000));
            }
            else {
              rescheduleCheck(5000);
            }
          }
        }

      }, function (err) {
        Utils.handleError(err);
        if (_.get($state.current, "data.anonymousAccess") == true) {
          //console.log("no logout cause you are allowed");
        } else {
          doLogout();
        }
      });

    }

  }

  function forceInit() {
    disable();
    init();
  }

  function init() {
    //console.log("SE:", "  init ", checkSessionTimeout);
    if (!AuthenticationService.getCheckSessionTimeout()) {
      //console.log("SE:", "  check session in 5000");
      rescheduleCheck(5000);
    }
    else {
      //$log.log("check session timeout already initialized");
    }
  }

  function disable() {
    //console.log("SE: ", " disable ", checkSessionTimeout);
    AuthenticationService.clearSessionTimeout();
  }

  function isActive() {
    return AuthenticationService.getCheckSessionTimeout() !== null ? true : false;
  }

  return {
    showExpirationDialog: showExpirationDialog,
    extendSession: extendSession,
    doLogout: doLogout,
    getSesionInformation: getSesionInformation,
    init: init,
    disable: disable,
    forceInit: forceInit,
    isActive: isActive
  };

}];



// WEBPACK FOOTER //
// ./src/ui/modules/dcb-eaccount/services/sessionExpiration/SessionExpirationService.js